module.exports = __webpack_public_path__ + "static/media/apc-vle-therapeutics-ltd.f9ac3e91.png";